<ng-container [ngSwitch]="configuration?.type">
    <zt-string-filter
        *ngSwitchCase="ZtTableHeaderType.STRING"
        (filterChange)="onFilterChange($event)"
    ></zt-string-filter>
    <zt-date-filter
        *ngSwitchCase="ZtTableHeaderType.DATE"
        (filterChange)="onFilterChange($event)"
    ></zt-date-filter>
    <zt-variants-filter
        *ngSwitchCase="ZtTableHeaderType.STRING_VARIANTS"
        [options]="configuration?.data"
        (filterChange)="onFilterChange($event)"
    ></zt-variants-filter>
    <div *ngSwitchDefault>
        <!-- The filter doesnot suport this data type currently. -->
    </div>
</ng-container>
